(function () {
  'use strict';

  class VeiculosDonoService {
    constructor(Restangular) {
      this.restangular = Restangular;
    }

    getVeiculos(uoId) {
      return this.restangular.all('veiculo/veiculos/permitidos/uoDona/' + uoId).getList();
    }

    mover(veiculoIds, uoId) {
      return this.restangular.all('veiculo/veiculos/permitidos/uoDona/' + uoId + '/list').post(veiculoIds);
    }
  }

  angular
    .module('veiculos')
    .service('VeiculosDonoService', VeiculosDonoService);
}());
